import { useLocation } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

const CanonicalUrl = () => {
  const location = useLocation();
  const siteUrl = 'https://ricksblackcarservicesantonio.com';
  
  // Construct canonical URL with proper path normalization
  let pathname = location.pathname;
  
  // Ensure trailing slash on all paths
  if (!pathname.endsWith('/')) {
    pathname = pathname + '/';
  }
  
  // Ensure lowercase
  pathname = pathname.toLowerCase();
  
  const canonicalUrl = `${siteUrl}${pathname}`;

  return (
    <Helmet>
      <link rel="canonical" href={canonicalUrl} />
    </Helmet>
  );
};

export default CanonicalUrl;
